import React from "react";
import Slider from "@ant-design/react-slick";

export default function Carousel() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div class="h-screen relative overflow-y-hidden">
      <Slider {...settings}>
        <div class="h-full">
          <img class="h-full" src={`${process.env.PUBLIC_URL}/images/carousel_1.JPG`} alt=""></img>
        </div>
        <div class="h-full">
          <img class="h-full" src={`${process.env.PUBLIC_URL}/images/carousel_2.JPG`} alt=""></img>
        </div>
        <div class="h-full">
          <img class="h-full" src={`${process.env.PUBLIC_URL}/images/carousel_3.JPG`} alt=""></img>
        </div>
        <div class="h-full">
          <img class="h-full" src={`${process.env.PUBLIC_URL}/images/carousel_4.JPG`} alt=""></img>
        </div>
      </Slider>
    </div>
  );
}
